/**
 * Generated runtime TestId mirror for frontend/src/components/attributes/InlineAttributeEditor.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const InlineAttributeEditorTestIds = {
  inlineAttributeEditor: "inline-attribute-editor",
  inlineAttributeEditorRetry: "inline-attribute-editor-retry",
  referenceLink: "reference-link",
  attr: (def_name: string) => `attr-${def_name}`,
  attrPrefix: () => "attr-" as TestIdPrefix,
  attributeAuthorityBadge: (def_name: string) => `attribute-authority-badge-${def_name}`,
  attributeAuthorityBadgePrefix: () => "attribute-authority-badge-" as TestIdPrefix,
  attributeRemove: (def_name: string) => `attribute-remove-${def_name}`,
  attributeRemovePrefix: () => "attribute-remove-" as TestIdPrefix,
  attributeReset: (def_name: string) => `attribute-reset-${def_name}`,
  attributeResetPrefix: () => "attribute-reset-" as TestIdPrefix,
  attributeRow: (def_name: string) => `attribute-row-${def_name}`,
  attributeRowPrefix: () => "attribute-row-" as TestIdPrefix,
  attributeSave: (def_name: string) => `attribute-save-${def_name}`,
  attributeSavePrefix: () => "attribute-save-" as TestIdPrefix
} as const;
